import './OtraHerramienta.scss';
import ReactGA from 'react-ga4';
import { useSelector } from 'react-redux';

export const OtraHerramenta = ({ enlace }) => {
  //Modificacion: Marca de Inicio WII C-24-1229-24
  const userId = useSelector((state: any) => state.authUser.userId);

  const abrirEnlace = () => {
    window.open(enlace.urlEnlace, '_blank');
    ReactGA.event('enlace_visto', {
      enlace_titulo: enlace.nombre,
      enlace_id: enlace.enlace_id,
      user_id: userId,
    });
  };
  //Modificacion: Marca de Fin WII C-24-1229-24
  return (
    <>
      <div className="otra-herramienta" onClick={() => abrirEnlace()}>
        <img src={enlace.urlImagen} />
        <div className="info-herramienta">
          <div className="h6 titulo tamaño">{enlace.nombre}</div>
        </div>
      </div>
    </>
  );
};
